<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">投放位</span>
        <el-input v-model="parameter.name" class="item_input" />
      </div>
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button v-if="tableData.is_admin" type="primary" icon="el-icon-circle-plus" @click="dialogVisible = true">创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="id"
        />
        <el-table-column
          prop="position_name"
          label="投放位"
        />
        <el-table-column
          prop="roi_coefficient"
          label="ROI系数"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
        />
        <el-table-column
          v-if="tableData.is_admin"
          label="操作"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="modify(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="data.id ? '修改投放位' : '创建投放位'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="(data.name = null),(data.id = null)"
    >
      <div class="content">
        <div class="item">
          <span class="item_title">投放位</span>
          <el-input v-model="data.name" class="item_input" />
        </div>
        <div class="item">
          <span class="item_title">RIO系数</span>
          <el-input v-model="data.roi_coefficient" class="item_input" type="number" @input="verification" />
        </div>
        <span style="color: #e22727;">注：RIO系数只能小数点后两位，多出将会被截掉</span>
      </div>
      <div style="display: flex; margin-top: 30px;justify-content: end;">
        <el-button type="primary" @click="determine">确定</el-button>
      </div>
    </el-dialog>

    <el-drawer
      title="详情"
      :visible.sync="drawer"
      :with-header="false"
      size="60%"
    >
      <Details v-if="drawer" :drawer-item="drawerItem" />
    </el-drawer>
  </div>
</template>

<script>
import { dropLocationList, addDropLocationList, modifyDropLocationList } from '@/api/newLaunchGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Details from './components/details.vue'
export default {
  components: {
    PaginationRight,
    Details
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        name: null
      },
      data: {
        name: null,
        roi_coefficient: null,
        id: null
      },
      dialogVisible: false,
      drawer: false,
      drawerItem: {}
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await dropLocationList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.data.name = row.position_name
      this.data.roi_coefficient = row.roi_coefficient
      this.data.id = row.id
    },

    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    async determine() {
      let text = null
      if (!this.data.name || !this.data.roi_coefficient) {
        text = !this.data.name ? '请填写投放位' : '请输入ROI系数'
      }
      text ? '' : this.data.id ? await modifyDropLocationList(this.data) : await addDropLocationList(this.data)
      this.$message({
        message: text || (this.data.id ? '更新成功' : '创建成功'),
        type: text ? 'warning' : 'success'
      })
      if (!text) {
        this.data.name = null
        this.data.roi_coefficient = null
        this.data.id = null
        this.dialogVisible = false
        this.getDataList()
      }
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    // 重置
    reset() {
      this.parameter.name = null
      this.parameter.page = 1
      this.parameter.page_size = 10
      this.getDataList()
    },

    verification(value) {
      this.data.roi_coefficient = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
     margin-bottom: 15px;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    .item_title{
       margin-right: 10px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}

</style>
